<script lang="ts">
    import {fade} from 'svelte/transition';

    import {ANIMATION_DURATION} from 'general/constants';

    import s from './style.module.css';

    export let children = '';
    export let reminderStatus: 'error';
</script>

{#if children}
    <p
        transition:fade={{duration: ANIMATION_DURATION.REMINDER}}
        class={s.reminder}
        class:error={reminderStatus === 'error'}
    >
        {children}
    </p>
{/if}
